module.exports = __webpack_public_path__ + "static/media/frothluxe-logo.263f48cd.png";